import { GraphQLPledge } from '@sola/schema/dotcom/supporters/schema.generated.ts';

import beyondMeasureLogo from '../../images/pledge-beyond-measure.png';
import { CommitmentAvatar } from '../commitment-avatar/commitment-avatar.tsx';

export const PledgeIcon = ({ pledgeName }: Partial<GraphQLPledge>) => {
  switch (pledgeName) {
    case 'Beyond Measure':
      return <CommitmentAvatar responsive imgSrc={beyondMeasureLogo} />;
    default:
      return <CommitmentAvatar responsive />;
  }
};
